import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {UiKitsModule} from './shared/ui-kits/ui-kits.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {DialogModule} from './shared/ui-kits/dialog/dialog.module';
import {ProfileModule} from './components/profile/profile.module';

// Libraries
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AuthModule} from '@auth0/auth0-angular';

// Components
import {AppComponent} from './app.component';
import {HomeComponent} from './components/home/home.component';
import {SettingsModule} from './components/settings/settings.module';
import {ErrorCatchingInterceptor} from './interceptors/error-catching.interceptor';
import {customNotifierOptions} from './shared/utils/notifier';
import {BearerInterceptor} from './interceptors/bearer.interceptor';
import {environment} from 'src/environments/environment';
import {ServiceWorkerModule} from '@angular/service-worker';
import {GlobalConfig, ToastrModule} from 'ngx-toastr';

@NgModule({ declarations: [AppComponent, HomeComponent],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        UiKitsModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        ProfileModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        SettingsModule,
        AuthModule.forRoot(environment.auth0Config),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.enableWorker,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        ToastrModule.forRoot(customNotifierOptions)], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorCatchingInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BearerInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
